module.exports = __webpack_public_path__ + "img/header-weddingRingsBlack@2x.1c0aeb0.webp";